import { type ObjectValuesUnionType } from '../utils/typing';

export const PromotionStatuses = Object.freeze({
  DEFAULT: 0, // no issue
  RM_ES_J30: 1, // RM ES J-30
  EXCLUDED: 2, // account excluded
  LOCKED: 3, // account locked
});

export type PromotionStatus = ObjectValuesUnionType<typeof PromotionStatuses>;
